import { Record } from 'immutable';

export default Record({
  key: undefined,
  name: undefined,
  image: undefined,
  backgroundColor: undefined,
  hoverBackgroundColor: undefined,
  resolveHref: undefined,
});
